import { useQuery } from '@tanstack/react-query'
import { fetchShopProducts, fetchShopProduct, fetchShopCategories } from '../api/shop'

export function useShopProducts(params = {}) {
  return useQuery({
    queryKey: ['shop-products', params],
    queryFn: () => fetchShopProducts(params),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}

export function useShopProduct(id) {
  return useQuery({
    queryKey: ['shop-product', id],
    queryFn: () => fetchShopProduct(id),
    staleTime: 5 * 60 * 1000,
    enabled: Boolean(id),
  })
}

export function useShopCategories() {
  return useQuery({
    queryKey: ['shop-categories'],
    queryFn: fetchShopCategories,
    staleTime: 10 * 60 * 1000,
    retry: 1,
  })
}
